/**
 * Detect the current platform that the current script is being hosted by
 *
 * @returns "wc" || "shopify" || "bc" || "hosted"
 */
export default function detectCurrentPlatform() {
    const realIdOrderData = window.realIdOrderData;
    // Check for BigCommerce via realIdOrderData (post-checkout)
    if (realIdOrderData?.platform === "bc") {
        console.debug("Real ID :: Platform detected: bc (via realIdOrderData)");
        return "bc";
    }
    // Check for BigCommerce checkout page via URL path (pre-checkout)
    // Our script is registered via BC Scripts API with visibility: "checkout"
    // so if we're on /checkout and running this script, we're on a BC checkout page
    // Note: We can't rely on window.checkoutConfig here because it may not be
    // initialized yet when our script runs (race condition with BC SDK)
    const isBcCheckoutUrl = window.location.pathname === "/checkout";
    if (isBcCheckoutUrl) {
        console.debug("Real ID :: Platform detected: bc (via /checkout URL path)");
        return "bc";
    }
    if ((window && window.woocommerce_params) ||
        window.realIdShopName ||
        window.realIdCustomerId ||
        window.realIdCurrentUser) {
        console.debug("Real ID :: Platform detected: wc");
        return "wc";
    }
    if (window && window.Shopify) {
        console.debug("Real ID :: Platform detected: shopify");
        return "shopify";
    }
    // no signs of WooCommerce, Shopify, or BigCommerce? Must be on our infrastructure
    console.debug("Real ID :: Platform detected: hosted (no platform signals found)");
    return "hosted";
}
